var map = {
	"./AI.png": "DjXM",
	"./area.png": "u8gE",
	"./avatar.png": "zQrT",
	"./bg.jpg": "Lr6H",
	"./biaogan.png": "i1Pm",
	"./blue.jpg": "KJEr",
	"./blue.png": "RYhz",
	"./circle.PNG": "1kdp",
	"./circle.jpg": "CuTA",
	"./finger.jpg": "nzGt",
	"./finger05.jpg": "cntS",
	"./genshu.png": "FFwg",
	"./golden-finger.png": "ZrqY",
	"./h3c-logo.png": "1tL3",
	"./help.png": "2+9l",
	"./image/B.svg": "iBPK",
	"./image/D.svg": "eQXQ",
	"./image/E.svg": "TXYW",
	"./image/F.svg": "5Dcy",
	"./image/H.svg": "bE78",
	"./image/L.svg": "siEk",
	"./image/P.svg": "DDg8",
	"./image/R.svg": "lnUF",
	"./image/V.svg": "04Tc",
	"./logo.png": "dLd/",
	"./logo2.png": "qvJq",
	"./moniqi.png": "hlHw",
	"./technique.png": "oc1q",
	"./title.png": "05xs",
	"./tool.png": "YnTg",
	"./yellow.jpg": "s7KP",
	"./zhiliao.png": "j5aA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "czpq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*$
// module id = czpq
// module chunks = 37